import { ApplicationState } from 'app/types-store';

export const selectRequestedModel = (state: ApplicationState) =>
  state.subscriberGroups?.userMembers?.requestedModel;

export const selectListBranch = (state: ApplicationState) =>
  state.subscriberGroups?.userMembers?.listBranch;

export const selectListBranchState = (state: ApplicationState) =>
  state.subscriberGroups?.userMembers?.listBranchState;

export const selectListActions = (state: ApplicationState) =>
  state.subscriberGroups?.userMembers?.listActions;

export const selectUpdating = (state: ApplicationState) =>
  state.subscriberGroups?.userMembers?.updating;

export const selectActionErrors = (state: ApplicationState) =>
  state.subscriberGroups?.userMembers?.actionErrors;

export const selectActiveValueError = (state: ApplicationState) =>
  state.subscriberGroups?.userMembers?.activeValueError;

export const selectSubscriberGroupValue = (state: ApplicationState) =>
  state.subscriberGroups?.userMembers?.subscriberGroup;

export const selectActiveValue = (state: ApplicationState) =>
  state.subscriberGroups?.userMembers?.subscriberGroup;

export const selectVisibility = (state: ApplicationState) =>
  state.subscriberGroups?.userMembers?.visiblity;

export const selectLastSelectedRow = (state: ApplicationState) =>
  state.subscriberGroups?.userMembers?.lastSelectedRow;

export const selectSelectedRows = (state: ApplicationState) =>
  state.subscriberGroups?.userMembers?.selectedRows;
